import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEllipseCircleVertical = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EllipseCircleVertical</title>
    <circle cx={16.002} cy={17.112} r={1.714} transform="rotate(90 16.002 17.112)" fill="currentColor" />
    <circle
      cx={15.998}
      cy={16.997}
      r={12.722}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={16} cy={10.255} r={1.714} transform="rotate(90 16 10.255)" fill="currentColor" />
    <circle cx={16.002} cy={23.97} r={1.714} transform="rotate(90 16.002 23.97)" fill="currentColor" />
  </svg>
);
export default SvgIcoEllipseCircleVertical;
